import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';
import _ from 'lodash'; // Import Lodash
import { TRACKER_FILTERS } from '../../config/const'


const state =  {
  articlesByUrls: {
    isBusy: false,
    data: null,
    error: null
  },
  originalArticlesByUrls: {
    data: null,
  },
  projectsByName:{
    isBusy: false,
    data: null,
    error: null
  },
  articlesXlsx:{
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_ARTICLES_BY_URLS_BUSY: (state, payload) => {
    state.articlesByUrls.isBusy = payload;
  },
  LOAD_ARTICLES_BY_URLS_SUCCESS: (state, payload) => {
    state.articlesByUrls.data = payload.data;
    state.originalArticlesByUrls.data = payload.data;
    state.articlesByUrls.error = null;
  },
  LOAD_ARTICLES_BY_URLS_FAIL: (state, payload) => {
    state.articlesByUrls.data = null;
    state.articlesByUrls.error = payload;
  },
  RESET_ARTICLES_BY_URLS_FILTER: (state, payload) => {
    state.articlesByUrls.data = _.cloneDeep(state.originalArticlesByUrls.data);
    if (payload.filter === TRACKER_FILTERS.FOUND) {
      state.articlesByUrls.data.data.forEach(item => {
        item.variants = item.variants.filter(variant => {
          if (payload.project !== null) {
            if (variant.insight !== null) {
              variant.insight = variant.insight.filter(insight => insight.project_id === payload.project);
            }
            if (variant.bodhi !== null) {
              variant.bodhi = variant.bodhi.filter(bodhi => variant.insight && variant.insight.some(insight => bodhi.id === insight.bodhi_id));
            }
            return variant.insight && variant.insight.length > 0;
          }
          return variant.insight !== null || variant.bodhi !== null
        });
      });
    } else if (payload.filter === TRACKER_FILTERS.NOT_FOUND) {
      state.articlesByUrls.data.data = state.articlesByUrls.data.data
        .map(item => ({
          ...item,
          variants: item.variants.filter(variant => {
            if (payload.project !== null) {
              const hasMatchingProject = variant.insight !== null && variant.insight.some(insight => insight.project_id === payload.project);
              const hasMatchingBodhi = variant.bodhi !== null && variant.insight !== null && variant.bodhi.some(bodhi => variant.insight.some(insight => bodhi.id === insight.bodhi_id));            
              return !(hasMatchingProject && hasMatchingBodhi);
            }
            return variant.insight === null && variant.bodhi === null;
          })
        }));
      } else if (payload.filter === TRACKER_FILTERS.EXACT_MATCH) {
        state.articlesByUrls.data.data = state.articlesByUrls.data.data.map(item => {
          const filteredVariants = item.variants.filter(variant => item.original_url === variant.url);
          if (filteredVariants.length === 0) {
            return {
              ...item,
              variants: [{
                url: item.original_url,
                insight:[],
                bodhi:[],
                crawler_id:[]
              }]
            };
          } else {
            return { ...item, variants: filteredVariants };
          }
        });
      }
      state.articlesByUrls.data.data = state.articlesByUrls.data.data.filter(item => item.variants.length > 0);
  },

  LOAD_PROJECTS_BY_NAME_BUSY: (state, payload) => {
    state.projectsByName.isBusy = payload;
  },
  LOAD_PROJECTS_BY_NAME_SUCCESS: (state, payload) => {
    state.projectsByName.data = payload.data;
    state.projectsByName.error = null;
  },
  LOAD_PROJECTS_BY_NAME_FAIL: (state, payload) => {
    state.projectsByName.data = null;
    state.projectsByName.error = payload;
  },
  LOAD_ARTICLES_XLSX_BUSY: (state, payload) => {
    state.articlesXlsx.isBusy = payload;
  },
  LOAD_ARTICLES_XLSX_SUCCESS: (state) => {
    state.articlesXlsx.error = null;
  },
  LOAD_ARTICLES_XLSX_FAIL: (state, payload) => {
    state.articlesXlsx.data = null;
    state.articlesXlsx.error = payload;
  }
};

const actions = {
  resetArticlesByFilter: ({ commit }, { filter, project }) => {
    commit('RESET_ARTICLES_BY_URLS_FILTER', {filter , project});
  },
  getArticlesByUrls: ({ commit, rootState }, { urls, project_id, start_date, end_date, pagination }) => {
    commit('LOAD_ARTICLES_BY_URLS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
    };

    const data = {
      urls: urls,
      project_id: project_id,
      start_date: start_date,
      end_date: end_date,
    };

    Axios
      .post(`${API_HOST}/articles_finder`, data, config)
      .then(response => {
        commit('LOAD_ARTICLES_BY_URLS_SUCCESS', response.data);
        commit('RESET_ARTICLES_BY_URLS_FILTER', {filter: TRACKER_FILTERS.EXACT_MATCH, project: project_id || null});
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_ARTICLES_BY_URLS_FAIL', error);
      })
      .finally(() => commit('LOAD_ARTICLES_BY_URLS_BUSY', false));
  },

  getAllProjectsByName: ({ commit, rootState }, { project_name, cancelToken }) => {
    commit('LOAD_PROJECTS_BY_NAME_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
      cancelToken
    };
    const data = {
     project_name
    };

    Axios
    .post(`${API_HOST}/articles_finder/projects`, data, config, )
    .then(response => {
      commit('LOAD_PROJECTS_BY_NAME_SUCCESS', response.data);
    })
    .catch(error => {
      if (!Axios.isCancel(error)) {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
        console.error(error);
        commit('LOAD_PROJECTS_BY_NAME_FAIL', error);
      }
    })
    .finally(() => commit('LOAD_PROJECTS_BY_NAME_BUSY', false));
  },
  
  exportArticlesFound: ({ commit, rootState }, { articles }) => {
    commit('LOAD_ARTICLES_XLSX_BUSY', true)
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
      responseType: 'blob',
    };
    const data = { articles };
    Axios
      .post(`${API_HOST}/articles_finder/export`, data, config)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'exported_articles.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
  
        commit('LOAD_ARTICLES_XLSX_SUCCESS');
      })
      .catch(error => {
        if (!Axios.isCancel(error)) {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });
          console.error(error);
          commit('LOAD_ARTICLES_XLSX_FAIL', error);
        }
      })
      .finally(() => commit('LOAD_ARTICLES_XLSX_BUSY', false));
  }  
};


export default {
  namespaced: true,
  state,
  mutations,
  actions
};